<div class="edi-document-detail" *ngIf="invoiceData">
  <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical" [collapsible]="true">
    <header libGungTabsetHeader class="document-page-header">
      <div class="document-identity">
        <span class="document-type">
          <span translate>INVOICE</span>
        </span>
        <h3>{{ invoiceData.id }}</h3>
        <p *ngIf="invoiceData.ediConfigId">{{ invoiceData.ediConfigId }}</p>
      </div>
      <div class="document-page-actions">
        <lib-edi-navigation-buttons [baseRoute]="ediNavigationBaseRoute"></lib-edi-navigation-buttons>
        <lib-edi-send-status class="edi-status-badge" [message]="invoiceData"></lib-edi-send-status>
        <lib-action-btn [(item)]="invoiceData" [config]="actionConfig"></lib-action-btn>
      </div>
    </header>
    <lib-gung-tab section="Document" icon="fa-solid fa-file-invoice-dollar" title="Gung internal representation">
      <ng-template libGungTabContent>
        <div class="document-sheet">
          <section class="document-section document-overview">
            <header class="section-heading">
              <div>
                <h4>References and dates</h4>
              </div>
            </header>

            <div class="overview-layout">
              <section class="reference-panel" aria-label="Invoice references">
                <div class="reference-groups">
                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Document references</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field document-field-primary">
                        <label for="invoiceMessageId">Message ID</label>
                        <input class="form-control" id="invoiceMessageId" type="text" [ngModel]="invoiceData.id" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="invoiceNumber" translate>INVOICE_NUMBER</label>
                        <input class="form-control" id="invoiceNumber" type="text" [(ngModel)]="invoiceData.documentReferences.invoice.id" [disabled]="configService.disable.invoiceNumber" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.invoice.externalId">
                        <label for="invoiceExternalId">Invoice external ID</label>
                        <input class="form-control" id="invoiceExternalId" type="text" [ngModel]="invoiceData.documentReferences.invoice.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="supplierOrderNumber" translate>SUPPLIER_ORDER_NUMBER</label>
                        <input class="form-control" id="supplierOrderNumber" type="text" [(ngModel)]="invoiceData.documentReferences.supplierOrder.id" [disabled]="configService.disable.valueDate" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.supplierOrder.externalId">
                        <label for="invoiceSupplierOrderExternalId">Supplier order external ID</label>
                        <input class="form-control" id="invoiceSupplierOrderExternalId" type="text" [ngModel]="invoiceData.documentReferences.supplierOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="buyerOrderNumber" translate>BUYER_ORDER_NUMBER</label>
                        <input class="form-control" id="buyerOrderNumber" type="text" [(ngModel)]="invoiceData.documentReferences.buyerOrder.id" [disabled]="configService.disable.buyerOrderNumber" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.buyerOrder.externalId">
                        <label for="invoiceBuyerOrderExternalId">Buyer order external ID</label>
                        <input class="form-control" id="invoiceBuyerOrderExternalId" type="text" [ngModel]="invoiceData.documentReferences.buyerOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.despatchAdvice.id">
                        <label for="despatchAdviceNumber" translate>DESPATCH_ADVICE_ID</label>
                        <input class="form-control" id="despatchAdviceNumber" type="text" [(ngModel)]="invoiceData.documentReferences.despatchAdvice.id" [disabled]="configService.disable.despatchAdviceNumber" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.relatedInvoice?.id">
                        <label for="relatedInvoiceNumber">Related invoice</label>
                        <input class="form-control" id="relatedInvoiceNumber" type="text" [ngModel]="invoiceData.documentReferences.relatedInvoice.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.invoiceOcr?.id">
                        <label for="invoiceOcr">Invoice OCR</label>
                        <input class="form-control" id="invoiceOcr" type="text" [ngModel]="invoiceData.documentReferences.invoiceOcr.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.orderMessageId">
                        <label for="invoiceSourceMessage">Source order message</label>
                        <input class="form-control" id="invoiceSourceMessage" type="text" [ngModel]="invoiceData.orderMessageId" [disabled]="true" />
                      </div>
                      <div class="document-field document-field-wide" *ngIf="invoiceData.erpIds?.length">
                        <label for="invoiceErpIds">ERP IDs</label>
                        <input class="form-control" id="invoiceErpIds" type="text" [ngModel]="invoiceData.erpIds.join(', ')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Timeline</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="invoiceDate" translate>INVOICE_DATE</label>
                        <input class="form-control" id="invoiceDate" type="text" [(ngModel)]="invoiceData.documentReferences.invoice.date" [disabled]="configService.disable.invoiceDate" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.invoiceDueDate">
                        <label for="invoiceDueDate">Due date</label>
                        <input class="form-control" id="invoiceDueDate" type="text" [ngModel]="invoiceData.invoiceDueDate" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.supplierOrder.date">
                        <label for="supplierOrderDate">Supplier order date</label>
                        <input class="form-control" id="supplierOrderDate" type="text" [ngModel]="invoiceData.documentReferences.supplierOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.buyerOrder.date">
                        <label for="buyerOrderDate" translate>BUYER_ORDER_DATE</label>
                        <input class="form-control" id="buyerOrderDate" type="text" [(ngModel)]="invoiceData.documentReferences.buyerOrder.date" [disabled]="configService.disable.buyerOrderDate" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.documentReferences.despatchAdvice.date">
                        <label for="despatchAdviceDate" translate>DESPATCH_ADVICE_DATE</label>
                        <input class="form-control" id="despatchAdviceDate" type="text" [(ngModel)]="invoiceData.documentReferences.despatchAdvice.date" [disabled]="configService.disable.despatchAdviceNumber" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.shipmentDate">
                        <label for="invoiceShipmentDate">Shipment date</label>
                        <input class="form-control" id="invoiceShipmentDate" type="text" [ngModel]="invoiceData.shipmentDate" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.deliveryDate">
                        <label for="deliveryDate" translate>DELIVERY_DATE</label>
                        <input class="form-control" id="deliveryDate" type="text" [(ngModel)]="invoiceData.deliveryDate" [disabled]="configService.disable.deliveryDate" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.timestamp">
                        <label for="timestamp" translate>TIMESTAMP</label>
                        <input class="form-control" id="timestamp" type="text" [ngModel]="invoiceData.timestamp" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.sentTimestamp">
                        <label for="deliveredTimestamp" translate>DELIVERED_TIMESTAMP</label>
                        <input class="form-control" id="deliveredTimestamp" type="text" [ngModel]="invoiceData.sentTimestamp | date : (dateUtilService.dateFormat + ' HH:mm')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Invoice attributes</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="invoiceKind">Invoice type</label>
                        <input class="form-control" id="invoiceKind" type="text" [ngModel]="invoiceData.creditInvoice ? 'Credit invoice' : 'Invoice'" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.currency">
                        <label for="currency" translate>CURRENCY</label>
                        <input class="form-control" id="currency" type="text" [(ngModel)]="invoiceData.currency" [disabled]="configService.disable.currency" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.supplierVatRegNumber">
                        <label for="supplierVatNumber">Supplier VAT number</label>
                        <input class="form-control" id="supplierVatNumber" type="text" [ngModel]="invoiceData.supplierVatRegNumber" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.supplierCompanyRegNumber">
                        <label for="supplierCompanyNumber">Supplier company number</label>
                        <input class="form-control" id="supplierCompanyNumber" type="text" [ngModel]="invoiceData.supplierCompanyRegNumber" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.deliveryTermId">
                        <label for="invoiceDeliveryTerm">Delivery term</label>
                        <input class="form-control" id="invoiceDeliveryTerm" type="text" [ngModel]="invoiceData.deliveryTermId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="invoiceData.paymentTermText">
                        <label for="invoicePaymentTerm">Payment terms</label>
                        <input class="form-control" id="invoicePaymentTerm" type="text" [ngModel]="invoiceData.paymentTermText" [disabled]="true" />
                      </div>
                    </div>
                  </section>
                </div>
              </section>

              <section class="party-panel" aria-label="Invoice parties">
                <div class="panel-heading">
                  <div>
                    <span>Invoice parties</span>
                  </div>
                </div>
                <lib-edi-gln-number-tabs
                  [ediMessage]="invoiceData"
                  [documentStyle]="true"
                ></lib-edi-gln-number-tabs>
              </section>
            </div>
          </section>

          <lib-edi-detail-error-display [ediMessage]="invoiceData"></lib-edi-detail-error-display>

          <section class="document-section document-lines">
            <header class="section-heading lines-heading">
              <div>
                <h4><span translate>INVOICE_ROWS</span></h4>
              </div>
              <span class="line-count">{{ itemCount }} items</span>
            </header>
            <lib-edi-row-table
              [data]="invoiceData.items"
              [columns]="itemsColumns"
              customClass="document-items-table"
            ></lib-edi-row-table>
          </section>

          <section class="document-section invoice-totals">
            <header class="section-heading">
              <div>
                <h4>Financial summary</h4>
              </div>
            </header>

            <div class="financial-grid">
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.lineItemsGrossAmount)">
                <span>Line items gross</span>
                <strong>{{ formatPrice(invoiceData.summary.lineItemsGrossAmount) }}</strong>
              </div>
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.lineItemsGrossTaxAmount)">
                <span>Line items gross tax</span>
                <strong>{{ formatPrice(invoiceData.summary.lineItemsGrossTaxAmount) }}</strong>
              </div>
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.lineItemsNetAmount)">
                <span>Line items net</span>
                <strong>{{ formatPrice(invoiceData.summary.lineItemsNetAmount) }}</strong>
              </div>
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.lineItemsNetTaxAmount)">
                <span>Line items net tax</span>
                <strong>{{ formatPrice(invoiceData.summary.lineItemsNetTaxAmount) }}</strong>
              </div>
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalFreightAmount)">
                <span>Freight</span>
                <strong>{{ formatPrice(invoiceData.summary.totalFreightAmount) }}</strong>
              </div>
              <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalAdminFeeAmount)">
                <span>Administration fee</span>
                <strong>{{ formatPrice(invoiceData.summary.totalAdminFeeAmount) }}</strong>
              </div>

              <div class="document-field amount-field" *ngIf="hasPrice(invoiceData.summary?.totalVATBaseAmount)">
                <label for="taxableAmount" translate>TAXABLE_AMOUNT</label>
                <div class="amount-input">
                  <input
                    class="form-control"
                    id="taxableAmount"
                    name="taxableAmount"
                    type="text"
                    [ngModel]="invoiceData.summary.totalVATBaseAmount.value"
                    (ngModelChange)="invoiceData.summary.totalVATBaseAmount.value = $event"
                    [disabled]="configService.disable.taxableAmount"
                  />
                  <span *ngIf="currencyFor(invoiceData.summary.totalVATBaseAmount) as currency">{{ currency }}</span>
                </div>
              </div>

              <div class="amount-card" *ngIf="hasValue(invoiceData.summary?.totalVATPercent)">
                <span>VAT percentage</span>
                <strong>{{ invoiceData.summary.totalVATPercent }}%</strong>
              </div>

              <div class="document-field amount-field" *ngIf="hasPrice(invoiceData.summary?.totalVATAmount)">
                <label for="totalTaxAmount" translate>TOTAL_TAX_AMOUNT</label>
                <div class="amount-input">
                  <input
                    class="form-control"
                    id="totalTaxAmount"
                    name="totalTaxAmount"
                    type="text"
                    [ngModel]="invoiceData.summary.totalVATAmount.value"
                    (ngModelChange)="invoiceData.summary.totalVATAmount.value = $event"
                    [disabled]="configService.disable.totalTaxAmount"
                  />
                  <span *ngIf="currencyFor(invoiceData.summary.totalVATAmount) as currency">{{ currency }}</span>
                </div>
              </div>

              <div class="document-field amount-field" *ngIf="hasPrice(invoiceData.summary?.totalRoundingAmount)">
                <label for="rounding" translate>ROUNDING</label>
                <div class="amount-input">
                  <input
                    class="form-control"
                    id="rounding"
                    name="rounding"
                    type="text"
                    [ngModel]="invoiceData.summary.totalRoundingAmount.value"
                    (ngModelChange)="invoiceData.summary.totalRoundingAmount.value = $event"
                    [disabled]="configService.disable.rounding"
                  />
                  <span *ngIf="currencyFor(invoiceData.summary.totalRoundingAmount) as currency">{{ currency }}</span>
                </div>
              </div>

              <div
                class="document-field amount-field payable-field"
                *ngIf="hasPrice(invoiceData.summary?.totalPayableAmount)"
              >
                <label for="payableAmount">Payable amount</label>
                <div class="amount-input">
                  <input
                    class="form-control"
                    id="payableAmount"
                    name="payableAmount"
                    type="text"
                    [ngModel]="invoiceData.summary.totalPayableAmount.value"
                    (ngModelChange)="invoiceData.summary.totalPayableAmount.value = $event"
                    [disabled]="configService.disable.netAmout"
                  />
                  <span *ngIf="currencyFor(invoiceData.summary.totalPayableAmount) as currency">{{ currency }}</span>
                </div>
              </div>
            </div>

            <section class="vat-breakdown" *ngIf="invoiceData.summary?.vatLevels?.length">
              <div class="subsection-heading">
                <div>
                  <span>Tax detail</span>
                  <h5>VAT breakdown</h5>
                </div>
                <small>{{ invoiceData.summary.vatLevels.length }} VAT levels</small>
              </div>
              <div class="table-responsive">
                <table class="table vat-table">
                  <thead>
                    <tr>
                      <th>VAT rate</th>
                      <th>Taxable base</th>
                      <th>VAT amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let vatLevel of invoiceData.summary.vatLevels">
                      <td>{{ vatLevel.vatPercent }}%</td>
                      <td>{{ formatPrice(vatLevel.vatBaseAmount) }}</td>
                      <td>{{ formatPrice(vatLevel.vatAmount) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <details class="bookkeeping-amounts" *ngIf="hasBookkeepingAmounts">
              <summary>
                <span>
                  <strong>Bookkeeping currency</strong>
                </span>
                <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
              </summary>
              <div class="bookkeeping-grid">
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalPayableAmountBookkeepingCurrency)">
                  <span>Payable amount</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalPayableAmountBookkeepingCurrency) }}</strong>
                </div>
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalVATBaseAmountBookkeepingCurrency)">
                  <span>VAT base</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalVATBaseAmountBookkeepingCurrency) }}</strong>
                </div>
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalVATAmountBookkeepingCurrency)">
                  <span>VAT amount</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalVATAmountBookkeepingCurrency) }}</strong>
                </div>
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalFreightAmountBookkeepingCurrency)">
                  <span>Freight</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalFreightAmountBookkeepingCurrency) }}</strong>
                </div>
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalAdminFeeBookkeepingCurrency)">
                  <span>Administration fee</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalAdminFeeBookkeepingCurrency) }}</strong>
                </div>
                <div class="amount-card" *ngIf="hasPrice(invoiceData.summary?.totalRoundingAmountBookkeepingCurrency)">
                  <span>Rounding</span>
                  <strong>{{ formatPrice(invoiceData.summary.totalRoundingAmountBookkeepingCurrency) }}</strong>
                </div>
              </div>
            </details>
          </section>
        </div>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      section="Related EDI messages"
      icon="fa-solid fa-cart-arrow-down"
      title="Source EDI order"
      *ngIf="invoiceData.orderMessageId"
      [link]="['/admin/edi/orders', invoiceData.orderMessageId]"
    ></lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-reply" [title]="'ORDER_RESPONSES' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="ordrsp"
          [relations]="relations"
          [ediConfigId]="invoiceData.ediConfigId"
          [currentMessageId]="invoiceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-truck" [title]="'RELATED_EDI_DESADV' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="desadv"
          [relations]="relations"
          [ediConfigId]="invoiceData.ediConfigId"
          [currentMessageId]="invoiceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-file-invoice" [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="invoice"
          [relations]="relations"
          [ediConfigId]="invoiceData.ediConfigId"
          [currentMessageId]="invoiceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      *ngFor="let erpOrderId of erpOrderIds"
      section="ERP orders"
      icon="fa-solid fa-boxes-stacked"
      [title]="erpOrderId"
      [link]="['/orders', erpOrderId]"
    ></lib-gung-tab>
    <lib-gung-tab section="External EDI"
      icon="fa-solid fa-file-lines"
      title="External EDI representation"
      *ngIf="invoiceData.fileNameInclPath && (documentViewerEnabled$ | async)"
    >
      <ng-template libGungTabContent>
        <div class="pt-4">
          <lib-edi-document-viewer
            [messageId]="invoiceData.id"
            messageType="INVOICE"
            [useAi]="true"
          ></lib-edi-document-viewer>
        </div>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>
